var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "component",
      staticClass: "grid grid-cols-1 gap-x-[20px] lg:gap-x-[50px]",
      style: "min-height: " + _vm.height + "px"
    },
    [
      _c("form-base", {
        ref: "form",
        staticClass:
          "office-form grid grid-cols-1 lg:grid-cols-2 gap-[19px] lg:gap-y-[19px] lg:gap-x-[19px] h-full lg:h-auto",
        on: { submit: _vm.submit },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var loading = ref.loading
              var success = ref.success
              return [
                _vm._l(_vm.parsedFields, function(parsedField, index) {
                  return _c("form-" + parsedField.formInput, {
                    key: index,
                    tag: "component",
                    class: parsedField.formClass,
                    attrs: {
                      placeholder: parsedField.placeholder,
                      label: parsedField.label,
                      name: parsedField.name,
                      type: parsedField.type,
                      rules: parsedField.rules,
                      options: parsedField.options
                    },
                    model: {
                      value: _vm.payload[parsedField.name],
                      callback: function($$v) {
                        _vm.$set(_vm.payload, parsedField.name, $$v)
                      },
                      expression: "payload[parsedField.name]"
                    }
                  })
                }),
                _vm._v(" "),
                _c("form-error", {
                  staticClass: "lg:col-span-2 ",
                  attrs: { "error-response": _vm.errorResponse }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "lg:col-span-2 flex items-center  gap-32 mt-24"
                  },
                  [
                    _c(
                      "form-submit",
                      {
                        staticClass: "!bg-brown !text-white",
                        attrs: {
                          disabled: invalid,
                          loading: loading,
                          success: success
                        }
                      },
                      [_vm._v("verstuur")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.success_message))
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }